/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'
import {
    Cells,
    Cell,
    CellBody,
    CellFooter,
} from 'react-weui'

class LiveroomCell extends React.Component {
    static defaultProps = {
        body: '',
        footer: '',
        method: () => {}
    };

    render (){
        const {body, footer, method} = this.props;
        return (
            <Cells>
                <Cell onClick={method} access>
                    <CellBody>
                        {body}
                    </CellBody>
                    <CellFooter>
                        {footer}
                    </CellFooter>
                </Cell>
            </Cells>
        )
    }
}

export default LiveroomCell


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/LiveroomCell.js